import cx from 'classnames';
import { Close } from 'education-icons';
import React, { useContext } from 'react';
import { CSSTransition } from 'react-transition-group';
import { useMedia } from 'react-use';

import { MEDIA_QUERY_MOBILE_L } from '../../../utils/von-dyck-media-queries';
import KeyboardContext from '../keyboard-context';
import { KEYBOARD_TYPES } from '../types';

import './keyboard_type_primary.scss';

interface Props {
    mix: string;
}

export const Keyboard = ({ mix }: Props) => {
    /**
     * Prevent currently focused input from blur.
     */
    const handleMouseDown = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        e.preventDefault();
    };

    const handleClose = () => {
        if (document?.activeElement instanceof HTMLElement) {
            document.activeElement.blur();
        }
    };

    const { shouldShowKeyboard, setRef } = useContext(KeyboardContext)[KEYBOARD_TYPES.PRIMARY];
    const isSmallScreen = useMedia(MEDIA_QUERY_MOBILE_L);

    return (
        <div className="keyboard__wrapper">
            <CSSTransition
                classNames="keyboard__animation"
                in={shouldShowKeyboard}
                mountOnEnter={true}
                timeout={300}
                unmountOnExit={true}
            >
                <div className={cx('keyboard', mix)} onMouseDown={handleMouseDown}>
                    <div className="keyboard__portal" ref={setRef} />
                    {!isSmallScreen && (
                        <div className="keyboard__close-button" onClick={handleClose}>
                            <Close className="keyboard__close-button-icon" />
                        </div>
                    )}
                </div>
            </CSSTransition>
        </div>
    );
};

export default Keyboard;
